export enum AdvertSlot {
  SiteBanner = 'siteBanner',
  HomepageBanner = 'homepageBanner',
  CategoryIndexOne = 'categoryIndexOne',
  CategoryIndexTwo = 'categoryIndexTwo',
  VideoPageOne = 'videoPageOne',
  VideoPageTwo = 'videoPageTwo',
  VideoPageMobileOne = 'videoPageMobileOne',
  VideoPageMobileTwo = 'videoPageMobileTwo'
}

export enum serverSlotsToClientSlots {
  siteBanner = 'siteBanner',
  homepageBanner = 'homepageBanner',
  categoryIndexOne = 'categoryIndexOne',
  categoryIndexTwo = 'categoryIndexTwo',
  videoPageOne = 'videoPageOne',
  videoPageTwo = 'videoPageTwo',
  videoPageMobileOne = 'videoPageMobileOne',
  videoPageMobileTwo = 'videoPageMobileTwo',
  siteBannerMobile = 'siteBanner',
  homepageBannerMobile = 'homepageBanner',
  categoryIndexOneTablet = 'categoryIndexOne',
  categoryIndexOneMobile = 'categoryIndexOne',
  categoryIndexTwoTablet = 'categoryIndexTwo',
  categoryIndexTwoMobile = 'categoryIndexTwo'
}
export default AdvertSlot;



// WEBPACK FOOTER //
// ./src/app/constants/advertSlot.ts